var app = angular.module("leonardo");

var DeleteWorkflowDialog = function($scope, WorkFlowInstanceService, FormErrorsService) {
  $scope.filters = $scope.ngDialogData.filters;
  
  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    WorkFlowInstanceService.clearInstances($scope.filters).then(function() {
      $scope.confirm();
    }, function (error) {
      $scope.closeThisDialog();
    });
  };

};

app.controller('DeleteWorkflowDialog', ['$scope', 'WorkFlowInstanceService', 'FormErrorsService', DeleteWorkflowDialog]);
